import React from "react";

import Box from "@mui/material/Box";

const MobileTopBackground: React.FC = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: "35vh",
        zIndex: -10,
      }}
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
        style={{ display: "block" }}
      >
        <path d="M0,0 L100,0 L100,100 L0,60 Z" fill="#0027FF" />
      </svg>
    </Box>
  );
};

export default MobileTopBackground;
